import {createSvgIcon} from '../create-svg-icon';

export const CurrencyFrancIcon = createSvgIcon(
  <path d="M18 5V3H7v13H5v2h2v3h2v-3h4v-2H9v-3h8v-2H9V5z" />
, 'CurrencyFrancOutlined');
